import React, { useState, useEffect } from "react";

import { ReactComponent as PlusSVG } from "../../../assets/plus.svg";
import { ReactComponent as MinusSVG } from "../../../assets/minus.svg";
import { OPContainer, OPWrapper } from "../settings/SettingsStyled";
import { Box, Button, BackBtn, Header, BtnGroup, Btn } from "./SetBetStyled";

import useBetOperations from "../../bets";

export default ({
  bet,
  handleBetAmount,
  handleAbove,
  handleNotification,
  notifyText,
  aboveAnim,
  handleAboveAnim,
  userInfo,
  userSettings,
  audio,
}) => {
  const { minBet, maxBet, curr, precision } = userInfo;
  const [value, setvalue] = useState(bet);
  const [inputValue, setinputValue] = useState(value || "");
  const [devA, setDevA] = useState(false);
  const [x2A, setx2A] = useState(false);
  const [x5A, setx5A] = useState(false);
  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);
  const [setA, setSetA] = useState(false);
  const [backA, setBackA] = useState(false);
  const [soundPlayed, setSoundPlayed] = useState(false);
  const [
    useBet,
    plus,
    minus,
    multiply,
    divide,
    handleButtonPress,
    handleButtonRelease,
  ] = useBetOperations(
    value,
    userSettings.volume,
    userSettings.sound,
    handleNotification,
    minBet,
    maxBet,
    curr,
    precision
  );

  useEffect(() => {
    setvalue(useBet);
    setinputValue(useBet);
  }, [useBet]);
  const handleChange = (e) => {
    const onlyNumbersAndDot = /^\d*\.?\d*$/;
    const n = e.target.value;
    if (onlyNumbersAndDot.test(n)) {
      if (n.indexOf(".") !== -1) {
        if (n.length - n.indexOf(".") < precision + 2) {
          setinputValue(n);
          handleNotification(false);
        }
      } else {
        setinputValue(n);
      }
    }
  };

  const handleBlur = (e) => {
    const n = e.target.value;
    const max = maxBet;
    const min = minBet;

    if (n < min || n === "" || n === ".") {
      setinputValue(min.toFixed(precision));
      setvalue(min);
      handleNotification(`Minimum stake limit is ${minBet.toFixed(precision)} ${curr}`);
    } else if (n > max) {
      setinputValue(max.toFixed(precision));
      setvalue(max);
      handleNotification(`Maximum stake limit is ${maxBet.toFixed(precision)} ${curr}`);
    } else if (n.startsWith(".")) {
      setinputValue(0 + n); ///  es ar momwons
      setvalue(0 + n);
    } else {
      setinputValue(n);
      setvalue(n);
      handleNotification(false);
    }
  };

  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };
  return (
    <OPContainer aboveAnim={aboveAnim} isDisabled={soundPlayed}>
      <OPWrapper>
        <Box aboveAnim={aboveAnim}>
          <Header>
            <p>{curr}</p>
            <input
              type="text"
              maxLength="10"
              value={inputValue}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Header>
          <div style={{ marginTop: "20%" }}>
            <BtnGroup>
              <Btn
                devA={devA}
                onClick={() => {
                  clearTimeout();
                  !notifyText && setAnimation(devA, setDevA);
                  divide();
                }}
              >
                1/2
              </Btn>
              <Btn
                x2A={x2A}
                onClick={() => {
                  clearTimeout();
                  !notifyText && setAnimation(x2A, setx2A);
                  multiply(2);
                }}
              >
                2x
              </Btn>
              <Btn
                x5A={x5A}
                onClick={() => {
                  clearTimeout();
                  !notifyText && setAnimation(x5A, setx5A);
                  multiply(5);
                }}
              >
                5x
              </Btn>
              <Btn
                minusPress={minusPress}
                onClick={() => {
                  minus();
                }}
                onTouchStart={() => {
                  !notifyText && setMinusPress(true);
                  handleButtonPress("acceleratableMinus");
                }}
                onTouchEnd={() => {
                  setMinusPress(false);
                  handleButtonRelease();
                }}
                onMouseDown={() => {
                  !notifyText && setMinusPress(true);
                  handleButtonPress("acceleratableMinus");
                }}
                onMouseUp={() => {
                  setMinusPress(false);
                  handleButtonRelease();
                }}
                onMouseLeave={() => {
                  setMinusPress(false);
                  handleButtonRelease();
                }}
              >
                <MinusSVG />
              </Btn>
              <Btn
                plusPress={plusPress}
                onClick={() => {
                  plus();
                }}
                onTouchStart={() => {
                  !notifyText && setPlusPress(true);
                  handleButtonPress("acceleratablePlus");
                }}
                onTouchEnd={() => {
                  setPlusPress(false);
                  handleButtonRelease();
                }}
                onMouseDown={() => {
                  !notifyText && setPlusPress(true);
                  handleButtonPress("acceleratablePlus");
                }}
                onMouseUp={() => {
                  setPlusPress(false);
                  handleButtonRelease();
                }}
                onMouseLeave={() => {
                  setPlusPress(false);
                  handleButtonRelease();
                }}
              >
                <PlusSVG />
              </Btn>
            </BtnGroup>
            <Button
              setA={setA}
              onClick={() => {
                setAnimation(setA, setSetA);
                handleBetAmount(useBet);
                audio.confirm();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnim(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 150);
                }, 100);
              }}
            >
              set
            </Button>
            <BackBtn
              backA={backA}
              onClick={() => {
                setAnimation(backA, setBackA);
                audio.goBack();
                setSoundPlayed(true);
                setTimeout(() => {
                  handleAboveAnim(false);
                  setTimeout(() => {
                    handleAbove(false);
                  }, 150);
                }, 100);
              }}
            >
              Back
            </BackBtn>
          </div>
        </Box>
      </OPWrapper>
    </OPContainer>
  );
};
